<header>
  <div class="container-fluid responsive-fixed-header px-0 wow fadeIn" data-wow-delay="0.1s">
<nav #navbar class="navbar navbar-expand-lg py-lg-0 px-lg-5 wow fadeIn" data-wow-delay="0.1s">
<a href="index.html" class="navbar-brand ms-4 ms-lg-0">
            <img src="assets/img/mykadainew.png" class="mykadai-logo"
                 >
        </a>
        <button type="button" class="navbar-toggler me-4" (click)="toggleNavbar()">
            <span class="navbar-toggler-icon">
                <i class="bi bi-list h1" [ngClass]="isNavbarCollapsed ? 'text-black' : 'text-black'"></i>
            </span>
        </button>
        <div [ngClass]="{ 'collapse navbar-collapse': true, show: !isNavbarCollapsed }" id="navbarCollapse">
            <div class="navbar-nav ms-auto p-4 p-lg-0">
                <a href="https://mykadai.varnik.cloud/#/" class="nav-item nav-link active">Home</a>
            </div>
        </div>
    </nav>
</div>
</header>


<!-- NAVBAR (Sidebar toggle for mobile) -->
<nav class="navbar navbar-dark sticky-top d-block d-lg-none py-3 nav-content">
  <div class="container-fluid">
    <a class="navbar-brand text-white fw-semibold">Table of Contents</a>
    <button
      class="navbar-toggler"
      type="button"
      (click)="toggleSidebar()"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>
</nav>

<!-- Offcanvas Sidebar (for mobile) -->
<div
  class="offcanvas offcanvas-start text-bg-dark"
  tabindex="-1"
  [class.show]="isSidebarOpen"
  (click)="closeSidebar()"
>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">Table of Contents</h5>
    <button
      type="button"
      class="btn-close btn-close-white"
      (click)="closeSidebar()"
    ></button>
  </div>
  <div class="offcanvas-body p-3">
    <!-- same sidebar content -->
   <ul class="list-unstyled mb-0">
      <li class="">
        <h5>App Workflow</h5>
        <ul class="list-unstyled mb-0">
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
             routerLink="/app-workflow"
              fragment="home-screen"
              >Home Screen</a
            >
          </li>

          <li class="mb-1">
            <a
              routerLink="/app-workflow"
              fragment="shop-products"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Shop Products</a
            >
          </li>

          <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="product-detail"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Product Detail</a
            >
          </li>

          <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="login"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Login / Register</a
            >
          </li>

          <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="cart-functionality"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Cart Functionality</a
            >
          </li>

          <li class="mb-1">
            <a
              routerLink="/app-workflow"
              fragment="wishlist"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Wishlist</a
            >
          </li>

            <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="cart"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >cart</a
            >
          </li>

          <li class="mb-1">
            <a
              routerLink="/app-workflow"
              fragment="orders"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Orders</a
            >
          </li>

          <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="addresses"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Addresses</a
            >
          </li>

          <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="reset-mpin"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Reset MPIN</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

<div class="d-flex manual-layout">
  <!-- Sidebar -->
  <aside class="sidebar text-white p-3 top-0 start-0 vh-100 d-none d-lg-block">
    <h4 class="fw-semibold mb-3 pt-lg-5 mt-lg-3 pt-0 mt-0">
      Table of Contents
    </h4>
    <ul class="list-unstyled mb-0">
      <li class="">
        <h5>App Workflow</h5>
        <ul class="list-unstyled mb-0">
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/app-workflow"
              fragment="home-screen"
              >Home Screen</a
            >
          </li>

          <li class="mb-1">
            <a
              routerLink="/app-workflow"
              fragment="shop-products"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Shop Products</a
            >
          </li>

          <li class="mb-1">
            <a
              routerLink="/app-workflow"
              fragment="product-detail"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Product Detail</a
            >
          </li>

          <li class="mb-1">
            <a
              routerLink="/app-workflow"
              fragment="login"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Login / Register</a
            >
          </li>

          <li class="mb-1">
            <a
              routerLink="/app-workflow"
              fragment="cart-functionality"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Cart Functionality</a
            >
          </li>

          <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="wishlist"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Wishlist</a
            >
          </li>

            <li class="mb-1">
            <a
              routerLink="/app-workflow"
              fragment="cart"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >cart</a
            >
          </li>

          <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="orders"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Orders</a
            >
          </li>

          <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="addresses"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Addresses</a
            >
          </li>

          <li class="mb-1">
            <a
             routerLink="/app-workflow"
              fragment="reset-mpin"
              class="text-white text-decoration-none d-block px-2 py-1 rounded"
              >Reset MPIN</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </aside>
  <!-- Main Content -->
  <main class="flex-grow-1 bg-light">
    <section class="manual-details bg-white p-4 rounded shadow-sm">
      <!-- HOME SCREEN -->

      <article id="note">
        <h3 class="text-bold text-danger">Note :</h3>
        <p class="text-danger">
          The app uses location services to determine the nearest shops, so
          appropriate permissions must be granted.
        </p>
        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/location.png"
            alt="location"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>

      <article id="home-screen">
        <h3 class="text-bold">1. Home Screen Overview</h3>
        <p>Default View:</p>
        <ul>
          <li>
            Displays nearest shops automatically based on the user's current
            location.
          </li>
          <li>
            Top quick filters show available categories (e.g., Mobile phone,
            Beauty, Personal Care).
          </li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/default-view.png"
            alt="default-view"
            class="img-fluid rounded shadow"
          />
        </div>

        <h5>Shop Sorting Options</h5>
        <ul>
          <li>Newest First – Recently added shops appear at the top.</li>
          <li>
            Nearest to Longest – Shops sorted by proximity, nearest first.
          </li>
          <li>
            Longest to Nearest – Shops sorted by distance, farthest first.
          </li>
        </ul>

        <h5>Bottom Navigation Bar (Footer)</h5>
        <p>The bottom nav is present on all major screens:</p>
        <ul>
          <li>Home – Return to main screen.</li>
          <li>My Orders – Past and ongoing orders.</li>
          <li>Cart – Items in shopping cart.</li>
          <li>Profile – Manage personal settings.</li>
        </ul>

        <h5>Navigation Drawer</h5>
        <p>The side menu includes:</p>
        <ul>
          <li>User name display</li>
          <li>My Orders, My Wishlist</li>
          <li>Dark/Light Theme Toggle</li>
          <li>Profile and Logout</li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/navigation-bar.png"
            alt="navigation-bar"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>

      <!-- SHOP PRODUCTS LIST -->
      <article id="shop-products" class="mt-4">
        <h3 class="text-bold">2. Shop Products List Screen</h3>
        <p>
          The Shop Products List screen shows shop details and a list of
          products for the selected shop.
        </p>

        <h5>Shop Details (Top Section)</h5>
        <ul>
          <li>Shop Name, Address, Operating Hours</li>
          <li>Wishlist / Favorite icon (toggle filled/outlined)</li>
        </ul>

        <h5>Product List Section</h5>
        <p>Displays products with filtering and sorting options:</p>
        <ul>
          <li>Category Filter (e.g., Pendrive)</li>
          <li>Sorting: Newest First, Price Low→High, Price High→Low</li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/product-list.png"
            alt="product-list"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>

      <!-- PRODUCT DETAIL -->
      <article id="product-detail" class="mt-4">
        <h3 class="text-bold">3. Product Detailed View</h3>
        <p>Shows full product details, wishlist and cart actions.</p>

        <h5>Product Image & Wishlist</h5>
        <ul>
          <li>Large product image at top.</li>
          <li>Heart icon to add/remove product from wishlist.</li>
        </ul>

        <h5>Price & Discount</h5>
        <ul>
          <li>Original price (strike-through)</li>
          <li>Discount %</li>
          <li>Final selling price highlighted</li>
        </ul>

        <div
          class="manual-steps mt-3 p-3 rounded border-start border-4 border-primary bg-light"
        >
          <h5>Add-to-Cart behavior</h5>
          <ol>
            <li>
              If user not logged in and taps Add to Cart → show login prompt and
              redirect back after login.
            </li>
            <li>
              Once added the button changes to "Added to cart" or "Go to cart".
            </li>
          </ol>

          <div class="img-box text-center my-3 img-box-2">
            <img
              src="assets/img/manual/discount-1.png"
              alt="discount"
              class="img-fluid rounded shadow"
            />
          </div>
          <div class="img-box text-center my-3">
            <img
              src="assets/img/manual/discount-2.png"
              alt="discount"
              class="img-fluid rounded shadow"
            />
          </div>
        </div>
      </article>

      <!-- LOGIN / REGISTER -->
      <article id="login" class="mt-4">
        <h3 class="text-bold">4. Login</h3>
        <p>Fields:</p>
        <ul>
          <li>Phone Number (10 digits)</li>
          <li>MPIN (4/6-digit secure input)</li>
        </ul>
        <p>Buttons & Links:</p>
        <ul>
          <li>Login (validates fields)</li>
          <li>Register Now → navigates to Registration screen</li>
          <li>Reset MPIN link → goes to Reset MPIN flow</li>
        </ul>

        <h5>On Successful Login</h5>
        <p>Navigate to login success screen and then Home/Dashboard.</p>

        <hr />

        <h4>Registration</h4>
        <ul>
          <li>Full Name, Email, Phone Number, MPIN (4-digit)</li>
          <li>Register button (validates required fields)</li>
        </ul>

        <h4>Reset MPIN (Login Screen):</h4>
        <ul>
          <li>Below the Login button, displayed a text link as reset Mpin</li>
          <li>
            When the user taps this link, navigate them to the Reset MPIN
            Screen.
          </li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/mpin.png"
            alt="reset-mpin"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>

      <!-- CART Functionality-->
      <article id="cart-functionality" class="mt-4">
        <h3 class="text-bold">5. Cart Functionality</h3>
        <h5>Add to Cart Button</h5>
        <ol>
          <li>Allows users to add the current product to the cart.</li>
          <li>
            <strong>Once added:</strong> The button changes to Go to cart or
            Added to cart,Prevents duplicate additions.
          </li>
        </ol>

        <h5>Replace Cart Alert (Cross-Shop)</h5>
        <p>
          If cart contains items from Shop A and user attempts to add from Shop
          B, show confirmation: "Your cart contains products from Shop A. Do you
          want to discard the selection and add products from Shop B?" Options:
          No / Replace
        </p>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/replace-cart.png"
            alt="replace-cart"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>

      <!-- WISHLIST -->
      <article id="wishlist" class="mt-4">
        <h3 class="text-bold">6. Wishlist</h3>
        <p>
          The Wishlist Screen allows users to save and manage their favorite
          products and shops for quicker future access. It provides two tabbed
          sections to separately display wishlisted products and wishlisted
          shops.
        </p>
        <p>
          Two tabs: Products (default) and Shops. Selected tab highlights with
          black background and white text.
        </p>
        <ul>
          <li>Products tab displays wishlisted products.</li>
          <li>Shops tab displays wishlisted shops.</li>
        </ul>
        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/tabs-selection.png"
            alt="tabs-selection"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>

      <!--Cart-->
      <article id="cart" class="mt-4">
        <h3 class="text-bold">7. Cart</h3>
        <p>
          The Cart Screen displays the list of items that the user has added to
          their shopping cart. It allows users to review, update quantities, and
          proceed to checkout.
        </p>

        <h5>Features</h5>
        <ol>
          <li>
            <strong>Product List:</strong> shows price (with tax), quantity
            controls (+ / −), and remove icon.
          </li>
          <li>
            <strong>Quantity Management:</strong> User can increase/decrease
            item count using + or – icons.
          </li>
          <li>
            <strong>Shop More Button:</strong> Redirects the user back to the
            product listing same shop screen to continue shopping.
          </li>
          <li>
            <strong>Summary Section:</strong> total items, total price, Checkout
            button.
          </li>
        </ol>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/cart.png"
            alt="cart"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>

      <!-- CHECKOUT -->
      <article id="checkout" class="mt-4">
        <h3 class="text-bold">8. Checkout & Order Placement</h3>
        <p>Collect delivery method, address and confirm order.</p>

        <h5>Delivery Options</h5>
        <ul>
          <li>Door Delivery</li>
          <li>Shop Pickup (address section adjusts)</li>
        </ul>

        <h5>Delivery Address</h5>
        <p>
          Selected address shows edit (pencil) icon and address type
          (Home/Work/Other).
        </p>

        <h5>Order Summary</h5>
        <ul>
          <li>List of products with qty and price</li>
          <li>Grand Total at bottom</li>
        </ul>

        <h5>Order Placement</h5>
        <p>
          Tapping "Place Order" opens confirmation dialog: Cancel / Confirm. If
          shop has payment enabled provide Pay Now / Skip Payment.
        </p>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/checkout-1.png"
            alt="Checkout"
            class="img-fluid rounded shadow"
          />
          <p class="caption text-muted fst-italic mt-2">
            Checkout interface example
          </p>
        </div>

        <h5>Success Screen</h5>
        <p>
          Large green check mark and the message: "Your Order Placed
          Successfully"
        </p>
        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/checkout-2.png"
            alt="Checkout"
            class="img-fluid rounded shadow"
          />
          <p class="caption text-muted fst-italic mt-2">
            Checkout interface example
          </p>
        </div>
      </article>

      <!-- ORDERS -->
      <article id="orders" class="mt-4">
        <h3 class="text-bold">9. Orders</h3>
        <p>
          Order Summary Screen shows list of past orders; tapping opens Order
          Details.
        </p>

        <h5>Order Card shows</h5>
        <ul>
          <li>Shop details</li>
          <li>Order date & time</li>
          <li>Total price</li>
          <li>Order status (Ordered, Accepted, Delivered, Cancelled)</li>
        </ul>

        <h5>Tap Behavior</h5>
        <ul>
          <li>Tapping the card navigates to the Order Details screen.</li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/tab-behaviour.png"
            alt="tab-behaviour"
            class="img-fluid rounded shadow"
          />
        </div>

        <h5>Order Details</h5>
        <ul>
          <li>Shop details, Order ID, Date/Time, Status</li>
          <li>Product breakdown</li>
          <li>Payment & Delivery details</li>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/payment.png"
            alt="payment"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>

      <!-- ADDRESS LIST -->
      <article id="addresses" class="mt-4">
        <h3 class="text-bold">10. Address List</h3>
        <h5>Purpose:</h5>
        <p>
          Max 3 addresses allowed. Each card shows address, edit and delete
          icons. FAB (+) to add a new address.
        </p>

        <h4>Screen Overview:</h4>
        <p>
          The Address List Screen displays all the user's saved addresses in a
          card layout. Each card contains the address information with edit and
          delete actions.
        </p>
        <h4>Address Card:</h4>
        <h5>Each card displays:</h5>
        <ul>
          <li>
            Address Details (Door No, Street, Area, Village, City, Landmark)
          </li>
          <li>Edit Icon:</li>
          <ul>
            <li>Tapping navigates to the Edit Address Screen</li>
          </ul>
          <li>Delete Icon</li>
          <ul>
            <li>Tapping deletes the address after a confirmation prompt</li>
          </ul>
        </ul>
        <h4>Add New Address Button:</h4>
        <ul>
          <li>
            A Floating Action Button (FAB) with a plus (+) icon is shown at the
            bottom-right of the screen.
          </li>
          <li>Tapping it navigates to the Add Address Screen.</li>
        </ul>
        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/add-address.png"
            alt="add-address"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>

      <!-- RESET MPIN -->
      <article id="reset-mpin" class="mt-4">
        <h3 class="text-bold">11. Reset MPIN</h3>
        <p>
          Allow users to securely reset their MPIN using their registered email
          ID through a two-step verification process.
        </p>

        <h5>Step 1 – Request Verification Code</h5>
        <ul>
          <li>Input:</li>
          <ul>
            <li>Registered Email Address</li>
          </ul>
          <li>Button:</li>
          <ul>
            <li>
              Send Verification Code → Sends 4-digit code and navigates to Step
              2
            </li>
          </ul>
          <li>Behavior:</li>
          <ul>
            <li>
              On clicking the button, a 4-digit verification code is sent to the
              entered email address and Navigate to Step 2 – Verification Screen
            </li>
          </ul>
        </ul>

        <h5>Step 2 – Enter Code & New MPIN</h5>
        <ul>
          <li>
            Input:
            <ul>
              <li>4-digit verification code</li>
              <li>New MPIN</li>
            </ul>
          </li>
          <li>Button:</li>
          <ul>
            <li>Reset MPIN</li>
          </ul>
        </ul>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/reset-mpin.png"
            alt="reset-mpin"
            class="img-fluid rounded shadow"
          />
        </div>
      </article>
    </section>
  </main>
</div>
